import React from "react";

function P2PLendingPlat() {
  return (
    <>
      <div className="container p-5">
        <div
          className="pricing-style-one-item-cos bg-dark text-light"
          style={{
            backgroundImage:
              "url(https://validthemes.net/site-template/robok/assets/img/shape/10.png)",
          }}
        >
          <div className="text-center">
            <h3>Why Choose Xeer for P2P Lending Platform Development?</h3>
            <div className="bottom">
              <div className="pricing">
                <p>
                  With expertise in blockchain and fintech, Xeer Technology
                  provides secure, scalable P2P lending solutions tailored to
                  your business model. Our solutions focus on regulatory
                  compliance, risk management, and user-centric design to
                  maximize platform success.
                </p>
              </div>
              <a className="btn btn-style-one mt-30" href="#">
                Get Started
              </a>
            </div>
          </div>
          {/* <div className="right-info"></div> */}
        </div>
      </div>
    </>
  );
}

export default P2PLendingPlat;
